// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see P2pPoolCreateP2pPoolCreateSuccessEvent
 */
export var P2pPoolCreateP2pPoolCreateSuccess = function (_a) {
    var poolToken = _a.poolToken, customerToken = _a.customerToken;
    return ({
        name: "P2pPool Create P2pPoolCreateSuccess",
        parameters: {
            cdf_entity: "P2pPool",
            cdf_action: "Create",
            pool_token: poolToken !== undefined && poolToken !== null ? poolToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see P2pPoolMemberAddedP2pPoolMemberAddedEvent
 */
export var P2pPoolMemberAddedP2pPoolMemberAdded = function (_a) {
    var poolToken = _a.poolToken, customerToken = _a.customerToken;
    return ({
        name: "P2pPool MemberAdded P2pPoolMemberAdded",
        parameters: {
            cdf_entity: "P2pPool",
            cdf_action: "MemberAdded",
            pool_token: poolToken !== undefined && poolToken !== null ? poolToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see P2pPoolMemberRemovedP2pPoolMemberRemovedEvent
 */
export var P2pPoolMemberRemovedP2pPoolMemberRemoved = function (_a) {
    var poolToken = _a.poolToken, customerToken = _a.customerToken;
    return ({
        name: "P2pPool MemberRemoved P2pPoolMemberRemoved",
        parameters: {
            cdf_entity: "P2pPool",
            cdf_action: "MemberRemoved",
            pool_token: poolToken !== undefined && poolToken !== null ? poolToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see P2pPoolContributeP2pPoolContributionSuccessEvent
 */
export var P2pPoolContributeP2pPoolContributionSuccess = function (_a) {
    var poolToken = _a.poolToken, customerToken = _a.customerToken;
    return ({
        name: "P2pPool Contribute P2pPoolContributionSuccess",
        parameters: {
            cdf_entity: "P2pPool",
            cdf_action: "Contribute",
            pool_token: poolToken !== undefined && poolToken !== null ? poolToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
